<div #deleteProjectWithMembers class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content border-radius-0">
      <div class="modal-header text-uppercase py-2 font-size-16">
        <div class="modal-title" i18n="@@app.delete_project_with_members">Delete project with members</div>
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body">
        <p>
          <span class="mr-1" i18n="@@app.this_project_has_been_shared_with">This project has been shared with other members. Do you want to delete the project or transfer write access to another member before deleting it?</span>
        </p>
      </div>
      <div class="modal-footer pt-1 border-0">
        <button type="button" (click)="closeModal()" class="btn btn-light btn-lg font-size-s text-uppercase border-rounded mx-2 font-weight-normal"
                i18n="@@app.cancel">Cancel</button>
        <button type="button" appDisableMultipleClick (click)="onDeleteProject()" class="btn btn-danger font-size-s btn-lg text-uppercase border-rounded mx-2 font-weight-normal"
                i18n="@@app.delete_project">Delete project</button>
        <button type="button" appDisableMultipleClick class="btn btn-primary btn-lg font-size-s text-uppercase border-rounded mx-2 font-weight-normal"
                (click)="onTransferOwnership()" i18n="@@app.transfer_ownership">Transfer ownership</button>
      </div>
    </div>
  </div>
</div>
